import {
	type AboutAIMessage,
	MessageRole,
	MessageType,
} from '../types/messageTypes'

export const placeholderResponses: Record<MessageType.AboutAI, AboutAIMessage> =
	{
		[MessageType.AboutAI]: {
			value: 'assistant.ai.answer.intro.text',
			disclaimers: [
				'assistant.ai.answer.generation.text',
				'assistant.ai.answer.learning.text',
				'assistant.ai.answer.stylists.text',
			],
			type: MessageType.AboutAI,
			role: MessageRole.Ai,
			showAvatar: true,
		},
	}
